import React from "react";
import { Button, Modal } from "react-bootstrap";

const inUseSentence = (count) =>
  count === 1 ? "1 class has warm-up groups on this set." : `${count} classes have warm-up groups on this set.`;

/** Asks before turning off a set some class still uses. */
export const TurnOffModal = ({ set, onCancel, onConfirm }) => (
  <Modal show={set !== null} onHide={onCancel}>
    <Modal.Header closeButton>
      <Modal.Title>{set && `Turn off ${set.key} ${set.name}?`}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {set &&
        `${inUseSentence(set.classroom_count)} Those groups keep working. Teachers cannot make new groups from it until you turn it back on.`}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onCancel}>
        Cancel
      </Button>
      <Button variant="primary" onClick={onConfirm}>
        Turn off
      </Button>
    </Modal.Footer>
  </Modal>
);
